module.exports = __webpack_public_path__ + "img/noble-level1-bg.4adf5ec3.png";